import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Params from '../options/Params';
import { UserInterface } from "./userInterface";

function renderApp() {
    Params.load();

    ReactDOM.render(
        <UserInterface />,
        document.getElementById('react-app')
    );
}

renderApp();